export class ScalesTableFileReadException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ScalesTableFileReadException';
  }
}
